module.exports = __webpack_public_path__ + "files/3b04828cf6cd748ebe069943af1b0922.svg";